var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',[_c(_vm.componentName,{ref:"CREATE_FORM",tag:"component",attrs:{"account":_vm.newAccountInfo,"current-item":_vm.currentItem}})],1),(_vm.componentName === 'create-cloudaccount')?_c('a-form-item',_vm._b({},'a-form-item',_vm.offsetFormLayout,false),[_c('test-button',{attrs:{"post":_vm.handleTest}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }